import { forwardRef, createElement } from 'react';

function IconInventory(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M10 15a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2.25a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm11.518-1.94l.04.121a1.25 1.25 0 01-.762 1.492l-.122.04-6.175 1.654.001-.117a4.48 4.48 0 00-.633-2.302l6.16-1.65a1.25 1.25 0 011.491.762zm-3.375-9.442l1.812 6.762a1 1 0 01-.707 1.224l-5.943 1.592a4.496 4.496 0 00-2.268-1.326L9.45 8.197a1 1 0 01.707-1.224l6.761-1.812a1 1 0 011.225.707zM3.657 1.536l.128.049 2.69 1.184c.304.133.54.381.66.686l.044.134L9.97 14l-.18.005a4.475 4.475 0 00-2.218.706L4.919 4.815l-2.141-.942a1.25 1.25 0 01-.69-1.52l.05-.128c.259-.59.918-.879 1.519-.689zM15.44 7.37a.75.75 0 00-.819-.55l-.1.02-1.449.388a.75.75 0 00.288 1.469l.1-.02 1.45-.388a.75.75 0 00.53-.919z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Inventory = /*#__PURE__*/forwardRef(IconInventory);

export default Inventory;
//# sourceMappingURL=Inventory.js.map
